<template>
  <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
          <th>#</th>
          <th>Номер ДБЗ</th>
          <th>Сумма</th>
          <th>{{ $t('payments.payment_date') }}</th>
          <th>До</th>
          <th>После</th>
          <th>Ошибка</th>
          <th>Дата импорта</th>
      </thead>
      <tbody>
        <template v-if="!load">
          <tr v-for="(excel, index) in excel.import_payments" :class="{'table-success': excel.status == 'done', 'table-danger': excel.status == 'failed'}">
              <td>{{index+1}}</td>
              <td>
                {{excel.debt_number}}
                <a :href="`/admin/debts?debt_number=${excel.debt_number}`" target="_blank" title="Найти">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </a>
              </td>
              <td>{{excel.amount}}</td>
              <td>{{excel.payment_date}}</td>
              <td>{{excel.old_current_arrears}}</td>
              <td>{{excel.new_current_arrears}}</td>
              <td>{{excel.errors}}</td>
              <td>{{excel.created_at}}</td>
          </tr>
        </template>
        <tr v-if="load">
          <td colspan="11" class="text-center">
            <loader-wave/>
          </td>
        </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    excel: Object,
    load: Boolean,
  },
}
</script>
